import type { CategoryLeaf } from '@repo/api-contracts';
import { ChevronRight } from 'lucide-react';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { storeCategoryPath } from '@/shared/config';

interface HomeCategoryRowProps {
  readonly category: CategoryLeaf;
}

/** 소분류 한 줄 — 이름과 오른쪽 화살표, 줄 전체가 그 소분류로 좁힌 스토어 목록 링크. */
export const HomeCategoryRow = ({ category }: HomeCategoryRowProps): ReactElement => (
  <li className="border-b border-foreground/10">
    <Link
      to={storeCategoryPath(category.id)}
      className="group flex items-center justify-between gap-4 py-4 transition-colors hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <span className="text-base font-medium sm:text-lg">{category.name}</span>
      <ChevronRight
        aria-hidden
        strokeWidth={1.5}
        className="size-5 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5 motion-reduce:transition-none"
      />
    </Link>
  </li>
);
